import {
  AnalyticsIcon,
  HomeIcon,
  InventoryIcon,
  PipelineIcon,
  SettingsIcon,
  VendorsIcon,
  FlipTradeIcon,
} from "../components/svg";
import {
  active,
  approved,
  awarded,
  bam_closed,
  closed,
  in_progress,
  inactive,
  not_initiated,
  ongoing,
  pending,
  rejected,
  sent,
} from "../constant/constant";

export const modules = {
  home: "home",
  projects: "projects",
  inventory: "inventory",
  vendors: "vendors",
  analytics: "analytics",
  reports: "reports",
  users: "users",
  roles: "roles",
  alerts: "alerts",
  templates: "templates",
  profile: "profile",
  change_password: "changepassword",
  graph: "graphs",
  aircraftmaster: "aircraft master",
  enginemaster: "engine master",
  aircraftfamily: "aircraft family & type",
  enginefamily: "engine family & type",
  aircrafttype: "aircraft type",
  enginetype: "engine type",
  fliptrading: "flip trading",
  app_master_lookup: "applicationmasterlookup",
  ils: "ILS",
  bam: "BAM approver",
  master_llp_values: "master LLP values",
  sales_esclation: "sales esclation",
  repairs_esclation: "repairs esclation",
  part_master: "part master",
  activity_flag_thresholds: "activity flag thresholds",
};

const {
  home,
  projects,
  inventory,
  vendors,
  analytics,
  users,
  roles,
  alerts,
  graph,
  templates,
  profile,
  change_password,
  aircraftmaster,
  enginemaster,
  aircraftfamily,
  enginefamily,
  fliptrading,
  app_master_lookup,
  ils,
  master_llp_values,
  sales_esclation,
  repairs_esclation,
  part_master,
  activity_flag_thresholds,
} = modules;

export const permissionsKey = {
  c: "C",
  r: "R",
  u: "U",
  d: "D",
  e: "E",
  i: "I",
  s: "S",
};

export const menuItems = [
  {
    text: "Home",
    icon: HomeIcon,
    path: "/home",
    hasNestedRoutes: true,
    module: [home],
  },
  {
    text: "Projects",
    icon: PipelineIcon,
    path: "/projects",
    module: [projects],
  },
  {
    text: "Inventory",
    icon: InventoryIcon,
    path: "/inventory",
    module: [inventory],
  },

  {
    text: "Vendors Management",
    icon: VendorsIcon,
    path: "/vendors",
    module: [vendors],
  },
  {
    text: "Flip Trading",
    icon: FlipTradeIcon,
    path: "/fliptrading",
    module: [fliptrading],
  },
  {
    text: "Analytics",
    icon: AnalyticsIcon,
    path: "/analytics",
    module: [analytics],
  },
  // {
  //   text: "Reports",
  //   icon: ReportsIcons,
  //   path: "/reports",
  //   module: [reports],
  // },
  {
    text: "Settings",
    icon: SettingsIcon,
    path: "/settings",
    module: [
      users,
      roles,
      alerts,
      templates,
      aircraftmaster,
      enginemaster,
      graph,
      profile,
      change_password,
      app_master_lookup,
      ils,
      master_llp_values,
      sales_esclation,
      repairs_esclation,
      part_master,
    ],
  },
];

export const settingsMenuItems = [
  { text: "Users", path: "/settings/users", module: [users] },
  { text: "Roles", path: "/settings/roles", module: [roles] },
  { text: "Alerts", path: "/settings/alerts", module: [alerts] },
  { text: "Template", path: "/settings/template", module: [templates] },
  //  { text: "Graphs", path: "/settings/graph", module: [graph] },
  {
    text: "Aircraft Family & Types",
    path: "/settings/aircraft-family",
    module: [aircraftfamily],
  },
  //  {
  //    text: "Aircraft Types",
  //    path: "/settings/aircraft-types",
  //    module: [aircrafttype],
  //  },
  //  {
  //    text: "Engine Types",
  //    path: "/settings/engine-types",
  //    module: [enginetype],
  //  },
  {
    text: "Engine Family & Types",
    path: "/settings/engine-family",
    module: [enginefamily],
  },
  // {
  //   text: "Aircraft Parts Master",
  //   path: "/settings/aircraft-master",
  //   module: [aircraftmaster],
  // },
  {
    text: "Engine Parts Master",
    path: "/settings/engine-master",
    module: [enginemaster],
  },
  // {
  //   text: "Application Master Lookup",
  //   path: "/settings/application-master-lookup",
  //   module: [app_master_lookup],
  // },
  // {
  //   text: "ILS",
  //   path: "/settings/ils",
  //   module: [ils],
  // },
  {
    text: "LLP Values",
    path: "/settings/llp-values",
    module: [master_llp_values],
  },
  {
    text: "Sales Escalation",
    path: "/settings/sales-escalation",
    module: [sales_esclation],
  },
  {
    text: "Repairs Escalation",
    path: "/settings/repair-escalation",
    module: [repairs_esclation],
  },
  {
    text: "Part Master",
    path: "/settings/part-master",
    module: [part_master],
  },
  {
    text: "Activity Flag Thresholds",
    path: "/settings/activity-flag-thresholds",
    module: [activity_flag_thresholds],
  },
];

export const profileSettingsMenuItems = [
  { text: "Profile", path: "/settings/profile", module: [profile] },
  {
    text: "Change Password",
    path: "/settings/change-password",
    module: [change_password],
    state: true,
  },
];

export const headerMenuItems = [
  ...profileSettingsMenuItems,

  { text: "Logout" },
];

export const accessOptions = [
  { value: "super_admin", label: "Super Admin" },
  { value: "sc", label: "SC Admin" },
  { value: "read", label: "Read" },
  { value: "write", label: "Write" },
  { value: "admin", label: "Admin" },
];

export const statusOptions = [
  {
    value: "Pending",
    label: "Pending",
  },
  {
    value: "Active",
    label: "Active",
  },
  {
    value: "Inactive",
    label: "Inactive",
  },
];

export const graphStatusOptions = [
  {
    value: "Active",
    label: "Active",
  },
  {
    value: "Inactive",
    label: "Inactive",
  },
];

export const exportMenuData = [
  { text: "EXCEL" },
  // { text: "PDF" },
  // { text: "DOC" },
];

export const matchSortKey = {
  created_by: "created_by__name",
  updated_by: "updated_by__name",
  roles: "roles__role_name",
  created_by_name: "created_by__name",
  aircraft_familiy: "aircraft_family__name",
  engine_familiy: "engine_family__name",
  msn_esn_number: "project_asset__msn_esn",
  typical_pn: "part_number",
  pn: "pn",
  pn_description: "pn_description",
  pipeline_qty: "pipeline_awarded_qty",
  RANKING_CATEGORY: "PNM_AUTO_KEY__RANKING_CATEGORY",
};

export const matchSortKeyVendor = {
  created_by: "created_by",
};

export const matchSortKeyVendorRepair = {
  pn: "PNM_AUTO_KEY__PN",
  pn_description: "PNM_AUTO_KEY__PN_DESCRIPTION",
};

export const allowedRoutes = ["/", "/access", "/logout"];

export const openMainLayoutRoutes = ["/access", "/logout"];

export const assetType = [
  { label: "Airframe", value: "Airframe" },
  { label: "Engine", value: "Engine" },
];
export const status = [
  { label: "Ongoing", value: "ongoing" },
  { label: "Closed", value: "closed" },
  { label: "Awarded", value: "awarded" },
];

export const bamStasues = [
  { label: "Not Initiated", value: 0 },
  { label: "Sent for Approval", value: 1 },
  { label: "Approved", value: 2 },
  { label: "Rejected", value: 3 },
  { label: "Closed", value: 4 },
];

export const importMenuItems = [
  { text: "Update Harvest List", value: "append" },
  { text: "Clear & Add Harvest List", value: "update" },
];

export const statusColorLable = [
  { id: 1, label: "Under stock", color: "#CEE741" },
  { id: 2, label: "In stock", color: "#FEF445" },
  { id: 3, label: "Over stock", color: "#F86E00" },
];

export const matchStatusStyle = {
  under_stock: "#CEE741",
  in_stock: "#FEF445",
  over_stock: "#F86E00",
};

export const tooltiPlacemetpProps = {
  placement: "top",
};

export const matchStatusStyleTable = {
  [active]: {
    backgroundColor: "var(--seagreen-color)",
    border: "1px solid var(--emerald-color)",
  },
  [in_progress]: {
    backgroundColor: "var(--tumeric-color)",
    border: "1px solid var(--gold-color)",
  },
  [ongoing]: {
    backgroundColor: "var(--tumeric-color)",
    border: "1px solid var(--gold-color)",
  },
  [awarded]: {
    backgroundColor: "var(--seagreen-color)",
    border: "1px solid var(--emerald-color)",
  },
  [pending]: {
    backgroundColor: "var(--tumeric-color)",
    border: "1px solid var(--gold-color)",
  },
  [inactive]: {
    backgroundColor: "var(--copper-color)",
    border: "1px solid var(--brown-color)",
  },
  [closed]: {
    backgroundColor: "var(--copper-color)",
    border: "1px solid var(--brown-color)",
  },
};

export const userStatusStyleTable = {
  [active]: {
    backgroundColor: "#c5f8d6",
    border: "1px solid var(--emerald-color)",
    color: " #16913f",
  },
  [pending]: {
    backgroundColor: " #f9fab1",
    border: "1px solid var(--gold-color)",
    color: " #aa900b",
  },
  [inactive]: {
    backgroundColor: " #ffe2c1",
    border: "1px solid var(--brown-color)",
    color: "#814908",
  },
};

export const bidStatusStyleTable = {
  [ongoing]: {
    backgroundColor: "var(--lighter-blue)",
    border: "1px solid var(--dark-blue)",
    color: "var(--text-dark-blue)",
  },
  [awarded]: {
    backgroundColor: "var(--lighter-green)",
    border: "1px solid var(--dark-green)",
    color: "var(--text-dark-green)",
  },
  [closed]: {
    backgroundColor: "var(--lighter-pink)",
    border: "1px solid var(--dark-red)",
    color: "var(--text-dark-red)",
  },
};

export const matchStatus = {
  in_progress: "In-Progress",
  ongoing: "Ongoing",
  closed: "Closed",
  awarded: "Awarded",
};

export const repairDropdown = [
  {
    label: "-",
    value: "",
  },
  {
    label: "Repair",
    value: "Repair",
  },
  {
    label: "Exchange",
    value: "Exchange",
  },
];

export const forcastForDropdown = [
  {
    label: "12 Months",
    value: "12",
  },
  {
    label: "12-24 Months",
    value: "24",
  },
  {
    label: "> 24 Months",
    value: ">24",
  },
];

export const inClude = [
  {
    label: "Yes",
    value: "Yes",
  },
  {
    label: "No",
    value: "No",
  },
];

export const assumedOptions = [
  { label: "None", value: 1 },
  { label: "Bare", value: 2 },
  { label: "Neutral", value: 3 },
  { label: "Full", value: 4 },
  { label: "Est. Value", value: 5 },
  { label: "Listed Below", value: 6 },
];

export const partOptions = [
  { label: "None", value: 1 },
  { label: "Fan Disk", value: 2 },
  { label: "Booster Spool", value: 3 },
  { label: "Fan Shaft", value: 4 },
];

export const moduleOtions = [
  { label: "LPC", value: "LPC" },
  { label: "HPC", value: "HPC" },
  { label: "HPT", value: "HPT" },
  { label: "LPT", value: "LPT" },
  { label: "IPC", value: "IPC" },
  { label: "IPT", value: "IPT" },
  { label: "Fan", value: "Fan" },
  { label: "Power Turbine", value: "Power Turbine" },
];

export const matchCondition = ["AR", "ar", "aR", "Ar"];

export const compareOptions = [
  {
    label: "Equal",
    value: "equal",
  },
  {
    label: "Not Equal",
    value: "not_equal",
  },
  // {
  //   label: "IN",
  //   value: "in",
  // },
  // {
  //   label: "Not In",
  //   value: "not_in",
  // },
  {
    label: "Less",
    value: "less",
  },
  {
    label: "Less or Equal",
    value: "less_or_equal",
  },
  {
    label: "Greater",
    value: "greater",
  },
  {
    label: "Greater or Equal",
    value: "greater_or_equal",
  },
  {
    label: "Between",
    value: "between",
  },
  {
    label: "Not Between",
    value: "not_between",
  },
  {
    label: "Is Null",
    value: "is_null",
  },
  {
    label: "Is Not Null",
    value: "is_not_null",
  },
];

/** Qty in stock comparison operators (excludes Is Null / Is Not Null). */
export const qtyCompareOptions = compareOptions.filter(
  (opt) => opt.value !== "is_null" && opt.value !== "is_not_null",
);

export const singleFieldOperators = [
  "equal",
  "not_equal",
  "less",
  "less_or_equal",
  "greater",
  "greater_or_equal",
  "in",
  "not_in",
];

export const doubleFieldOperators = ["between", "not_between"];

export const noFieldOperators = ["is_null", "is_not_null"];

export const getFmvValue = ({
  fmv_operator,
  fmv_value,
  fmv_start,
  fmv_end,
}) => {
  return getDynamicFilterValue({
    operator: fmv_operator,
    value: fmv_value,
    start: fmv_start,
    end: fmv_end,
  });
};

export const getDynamicFilterValue = ({ operator, value, start, end }) => {
  if (noFieldOperators.includes(operator)) {
    return operator === "is_null";
  }
  if (doubleFieldOperators.includes(operator)) {
    return [start, end];
  }
  if (singleFieldOperators.includes(operator)) {
    return value;
  }
  return value;
};

export const getQtyValue = ({
  qty_operator,
  qty_value,
  qty_start,
  qty_end,
}) => {
  return getDynamicFilterValue({
    operator: qty_operator,
    value: qty_value,
    start: qty_start,
    end: qty_end,
  });
};

export const alertTypeOption = [
  { value: "User reports", label: "User reports" },
  { value: "Project reports", label: "Project reports" },
];

export const frequencyOption = [
  { value: "Daily", label: "Daily" },
  { value: "Weekly", label: "Weekly" },
  { value: "Hourly", label: "Hourly" },
];

export const reportFormatOption = [{ value: "Excel", label: "Excel" }];

export const dayOfWeekOption = [
  { value: "Mon", label: "Mon" },
  { value: "Tue", label: "Tue" },
  { value: "Wed", label: "Wed" },
  { value: "Thu", label: "Thu" },
  { value: "Fri", label: "Fri" },
  { value: "Sat", label: "Sat" },
  { value: "Sun", label: "Sun" },
];

export const boolDropdown = [
  {
    label: "Yes",
    value: "True",
  },
  {
    label: "No",
    value: "False",
  },
];

export const matchBool = {
  Yes: true,
  No: false,
};

export const bamStatusStyle = {
  [not_initiated]: {
    backgroundColor: "var(--lighter-yellow)",
    border: "1px solid var(--dark-yellow)",
    color: "var(--text-dark-yellow)",
  },
  [sent]: {
    backgroundColor: "var(--lighter-blue)",
    border: "1px solid var(--dark-blue)",
    color: "var(--text-dark-blue)",
  },
  [approved]: {
    backgroundColor: "var(--lighter-green)",
    border: "1px solid var(--dark-green)",
    color: "var(--text-dark-green)",
  },
  [rejected]: {
    backgroundColor: "var(--lighter-reject-gray)",
    border: "1px solid var(--dark-red)",
    color: "var(--text-reject-light-red)",
  },
  [bam_closed]: {
    backgroundColor: "var(--lighter-pink)",
    border: "1px solid var(--dark-red)",
    color: "var(--text-dark-red)",
  },
};

export const intiateButton = [not_initiated];
export const approveButton = [sent, approved, rejected];
export const rejectButton = [sent, rejected];

export const stage_interval = 10000;

// aircraft
export const basic = "basic-details";
const harvest_list = "aircraft-harvestlist";
const inv_check = "aircraft-inventorycheck";
const pricing = "aircraft-pricing";
const cashflow = "aircraft-cashflow";
const ebitda = "aircraft-ebitda";

// engine
export const engine_basic = "engine-basic-details";
const engine_harvest_list = "engine-harvestlist";
const engine_inv_check = "engine-inventorycheck";
const engine_pricing = "engine-pricing";
const engine_cashflow = "engine-cashflow";
const engine_ebitda = "engine-ebitda";

export const assetStageMap = {
  [basic]: 0,
  [harvest_list]: 1,
  [inv_check]: 2,
  [pricing]: 3,
  [cashflow]: 4,
  [ebitda]: 5,
  [engine_basic]: 0,
  [engine_harvest_list]: 1,
  [engine_inv_check]: 2,
  [engine_pricing]: 3,
  [engine_cashflow]: 4,
  [engine_ebitda]: 5,
};
export const min_sales = "Minimum Sale Amount in the Last 12 Months";
export const max_sales = "Maximum Sale Amount in the Last 12 Months";

export const rowsPerPageOptions = [200, 500, 1000, "All"];

export const rowsPerPageOptionsINV = [200, 500, 1000];

export const stockVisibleOption = [
  { label: "Yes", value: "T" },
  { label: "No", value: "F" },
];

export const stock_visible_tabs = []; // sample values [1,4,5];

export const matchAssetType = {
  "aircraft-ebitda": "aircraft",
  "engine-ebitda": "engine",
};

export const pricingSummaryTooltip = {
  "Total Sales": "Sum of All Sales Values",
  "Total Repair Cost": "Sum of All Repair/Maintenance Costs",
  "Net Sales": "Total Sales − Total Repair Cost",
  "Total Proposed Dynamic Pricing":
    "Adjusted Sales Value Based on Market Conditions",
};

export const stockStatusOptions = [
  {
    label: "Under stock",
    value: "under_stock",
  },
  {
    label: "In stock",
    value: "in_stock",
  },
  {
    label: "Over stock",
    value: "over_stock",
  },
];

export const pricingCompletedStatus = ["completed", "complete"];

export const roStatusOptions = [
  { label: "CLOSED", value: "CLOSED" },
  { label: "QUERY", value: "QUERY" },
  { label: "RCVD_WSP", value: "RCVD_WSP" },
  { label: "QTE_APPVD", value: "QTE_APPVD" },
  { label: "QTE_RCVD", value: "QTE_RCVD" },
  { label: "SCRAP", value: "SCRAP" },
  { label: "AWAIT_CUST", value: "AWAIT_CUST" },
  { label: "CANCELLED", value: "CANCELLED" },
  { label: "RTN_SHIPPE", value: "RTN_SHIPPE" },
  { label: "REQTE_APPR", value: "RTN_SHIPPE" },
  { label: "RTN_ASIS", value: "RTN_ASIS" },
  { label: "REQTE_RCVD", value: "REQTE_RCVD" },
  { label: "OPEN", value: "OPEN" },
];

export const roWorkscopeOptions = [
  { label: "TEST", value: "TEST" },
  { label: "MODIFY", value: "MODIFY" },
  { label: "REPAIR", value: "REPAIR" },
  { label: "OTHER", value: "OTHER" },
  { label: "OVERHAUL", value: "OVERHAUL" },
];

export const repairTypeOptions = [
  { label: "Contract Repair", value: "Contract Repair" },
  { label: "Non-Contract Repair", value: "Non-Contract Repair" },
  { label: "Core Repair", value: "Core Repair" },
  { label: "Customer Repair", value: "Customer Repair" },
  { label: "Stock Repair", value: "Stock Repair" },
];

export const analyticsMultiSelectFields = [
  "application_code",
  "condition_code",
];

export const conditionCodes = {
  AR: "As Removed",
  BER: "Beyond Economical Repair",
  CHG: "CHG",
  EXP: "Expired Stock",
  FN: "Factory New",
  "HTS MOD": "HTS MOD",
  "I/R": "Inspected / Repaired",
  IN: "Inspected",
  INSP: "INSP",
  MO: "Modified",
  NE: "New",
  NS: "New Surplus",
  OH: "Overhauled",
  RE: "Repaired",
  RP: "Repairable",
  SC: "Scrap",
  SV: "Serviceable",
  TE: "Tested",
  Unknown: "Unknown",
  UR: "Under Review",
  US: "Unserviceable",
  XX: "Quarantine",
};

export const customGraphNames = ["Customer Quote", "Customer Quote Analytics"];

export const ACTIVITY_FLAGS = [
  { label: "GREEN", value: "GREEN" },
  { label: "AMBER", value: "AMBER" },
  { label: "RED", value: "RED" },
];

export const DATE_RANGES = [
  { label: "Last 30 Days", key: "30", value: "30" },
  { label: "Last 90 Days", key: "90", value: "90" },
  { label: "Last 6 Months", key: "6m", value: { unit: "months", amount: 6 } },
  { label: "Last 1 Year", key: "1y", value: { unit: "years", amount: 1 } },
  { label: "Last 2 Years", key: "2y", value: { unit: "years", amount: 2 } },
  { label: "Custom Range", key: "custom", value: "custom" },
];

export const greenStyle = {
  color: "#4caf50",
  bg: "#f0faf0",
  border: "#a5d6a7",
};
export const amberStyle = {
  color: "#f59e0b",
  bg: "#fffbf0",
  border: "#fcd34d",
};
export const redStyle = { color: "#ef4444", bg: "#fff5f5", border: "#fca5a5" };

export const flagThresholdsStyle = {
  Green: greenStyle,
  Amber: amberStyle,
  Red: redStyle,
};

export const VQ_STATUS = [
  {
    label: "CANCEL",
    value: "CANCEL",
  },
  {
    label: "CLOSED",
    value: "CLOSED",
  },
  {
    label: "OPEN",
    value: "OPEN",
  },
  {
    label: "QUOTED",
    value: "QUOTED",
  },
  {
    label: "SENT",
    value: "SENT",
  },
];

export const updateTimeModuleMatch = {
  0: null,
  1: "ods.view_Stock",
  2: "ods.view_Stock",
  3: "ods.view_Stock",
  4: "ods.view_Repairs",
  5: "ods.view_Repairs",
  6: "ods.view_Stock",
};
